module.exports = __webpack_public_path__ + "media/images/back-arrow-bfd3782b49d20dcd631d7761fb4de30d.svg";